import { Routes, Route } from "react-router-dom";

import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Cohort from "./components/Cohort";
import SystemPrompt from "./components/SystemPrompt";
import PrivateRoute from "./components/PrivateRoute";
import MainLayout from "./components/MainLayout";
import CohortsApproval from "./components/admin/CohortsApproval";
import MaterializeCohort from "./components/admin/MaterializeCohort";
import Runs from "./components/admin/Runs";
import Export from "./components/admin/Export";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/cohort"
        element={
          <PrivateRoute>
            <MainLayout>
              <Cohort />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/systemprompt"
        element={
          <PrivateRoute>
            <MainLayout>
              <SystemPrompt />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/cohort/:trace_id"
        element={
          <PrivateRoute>
            <MainLayout>
              <Cohort />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/cohorts-approval"
        element={
          <PrivateRoute>
            <MainLayout>
              <CohortsApproval />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/materialize"
        element={
          <PrivateRoute>
            <MainLayout>
              <MaterializeCohort />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/runs"
        element={
          <PrivateRoute>
            <MainLayout>
              <Runs />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/export"
        element={
          <PrivateRoute>
            <MainLayout>
              <Export />
            </MainLayout>
          </PrivateRoute>
        }
      />

    </Routes>
  );
}
